import(/* webpackMode: "eager" */ "/codebuild/output/src659718568/src/ui-directo/apps/customer/src/app/error.tsx");
